/*******************************************************
 ***************************************** fade element
 *******************************************************/
(function(h, e, f, g) {
    e.FadeScrolling = function(a) {
        this.$elem = h(a);
        this.init();
        this.events()
    };
    FadeScrolling.prototype.init = function() {
        var a = this;
        var b = (f.documentElement.scrollTop > 0) ? f.documentElement.scrollTop : f.body.scrollTop;
        a.$collection = h(".fade-in");
    };
    FadeScrolling.prototype.events = function() {
        var a = this;
        h(e).on("scroll", function() {
            a.call()
        });
        h(e).on("resize", function() {
            a.call()
        })
        a.call()
    };
    FadeScrolling.prototype.call = function(a) {
        var b = this;
        var c = (f.documentElement.scrollTop > 0) ? f.documentElement.scrollTop : f.body.scrollTop;
        b.$collection.each(function(d) {
            if (c > (h(this).offset().top + Math.min(h(this).outerHeight(true) / 2, 150)) - (h(e).height())) {
                if (h(this).hasClass("fade-in")) {
                    if (Modernizr.cssanimations) {
                        h(this).addClass("in")
                    } else {
                        h(this).animate({
                            opacity: 1
                        }, 500)
                    }
                }
            }
        })
    }
})($, window, document, undefined);
